import { getAPI } from "./base";

export async function fetchCountry() {
  try {
    const api = getAPI();
    const response = await api.get("/country");
    if (response.status === 200) {
      return response.data;
    } else {
      console.error("Error fetching data: ", response.statusText);
    }
  } catch (error) {
    console.error("Error fetching data: ", error);
  }
}
